import React, {createContext, useContext, useEffect, useState} from 'react';
import { safeGetItem, safeSetItem } from '../utils/safeStorage';

const CompareContext = createContext();

export const CompareProvider = ({children}) => {
    const [compareProducts, setCompareProducts] = useState(
        () => {
            const items = safeGetItem('compare');
            return items ? JSON.parse(items) : [];
        }
    );

    useEffect(() => {
        safeSetItem('compare', JSON.stringify(compareProducts));
    }, [compareProducts]);

    const addToCompare = (product) => {
        setCompareProducts([...compareProducts, product]);
    };

    const removeCompare = (sku) => {
        setCompareProducts([...compareProducts.filter((product) => product.sku != sku)]);
    };

    return (
        <CompareContext.Provider value={
            {
                addToCompare,
                removeCompare,
                compareProducts,
                setCompareProducts
            }
        }>
            {children}
        </CompareContext.Provider>
    );
};

export const useCompare = () => {
    return useContext(CompareContext);
};
